import React, { useContext, useEffect, useState } from "react";
import FontFaceObserver from "fontfaceobserver";
import globalComp from "../../../../global/components";
import { ProductContext, CanvasContext, ModuleContext } from "../../provider";
import ff from "../../../../util/fabric";

interface FontFamilyProps {
  number: number;
}

function FontFamily({ number }: FontFamilyProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { canvasRef, scaledCanvasSize } = useContext(CanvasContext);
  const { appConfig } = useContext(ProductContext);
  const { setModuleInfo, moduleInfo } = useContext(ModuleContext);

  useEffect(() => {
    if (moduleInfo && canvasRef.current) {
      // apply text color changes
      ff.editTextColor(canvasRef.current, moduleInfo.textColor);
      canvasRef.current.renderAll();
      // apply font-family changes
      let myFont = new FontFaceObserver(moduleInfo.fontFamily);
      myFont.load().then(function() {
        ff.editTextFontFamily(canvasRef.current, moduleInfo.fontFamily);
        canvasRef.current.renderAll();
      });
    }
  }, [moduleInfo, canvasRef, scaledCanvasSize]);

  return (
    moduleInfo && (
      <globalComp.FieldHeader
        number={number}
        title={t.select_font_type}
        tooltipStr={t.select_font_type_tooltip}
        extraCssClass={"pb-1"}
        element={
          <div className={"d-flex flex-wrap"}>
            {appConfig[
              window.INITIAL_DATA.LANGUAGE == "ru"
                ? "cyrillicFonts"
                : "latinFonts"
            ].map((font, index) => (
              <button
                key={`${font}-${index}`}
                style={{ fontFamily: font, fontSize: 16 }}
                className={`btn btn-sm btn-light btn-no-outline mr-2 mb-2 ${
                  moduleInfo.fontFamily == font
                    ? "border-primary text-primary"
                    : ""
                }`}
                onClick={() => {
                  setModuleInfo({ ...moduleInfo, fontFamily: font });
                }}>
                {font}
              </button>
            ))}
          </div>
        }
      />
    )
  );
}

export default FontFamily;
